export const DriverType = 'driver';
export const CarrierType = 'carrier';
export const ShipperType = 'shipper';
